import React, { useState, useEffect } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { MdOutlineSettings } from "react-icons/md";
import { FaRegAddressCard } from "react-icons/fa";
import { IoMdInformationCircleOutline } from "react-icons/io";
import styles from "./CabineDetailsDrawer.module.scss";
import SettingsCab from "./SettingsCab";
import ChangeAdressCab from "../infos/ChangeAdressCab";
import SpecificInfosCab from "../infos/SpecificInfosCab";

export default function CabineDetailsDrawer({
  cab,
  cabId,
  setCabId,
  aboId,
  maj,
  setMaj,
  updateCabType,
  setUpdateCabType,
  cabinesByAbo,
  displaySettingCab,
  setDisplaySettingCab,
  cabineAccess,
  isSearchingSettingCab,
  setIsSearchingSettingCab,
  majCabine,
  setMajCabine,
  initialSection,
}) {
  const [settingsOpen, setSettingsOpen] = useState(initialSection === "settings");
  const [addressOpen, setAddressOpen] = useState(initialSection === "address");
  const [infosOpen, setInfosOpen] = useState(initialSection === "infos");

  // When initialSection changes (user clicks a different card), update accordions
  useEffect(() => {
    setSettingsOpen(initialSection === "settings");
    setAddressOpen(initialSection === "address");
    setInfosOpen(initialSection === "infos");
  }, [initialSection]);

  return (
    <div className={styles.drawerWrap}>
      {/* Section Paramètres cabine */}
      <div className={styles.drawerSection}>
        <button
          type="button"
          className={styles.collapsibleHeader}
          onClick={() => setSettingsOpen((prev) => !prev)}
        >
          <span className={styles.drawerSectionTitle}>
            <MdOutlineSettings className={styles.sectionIcon} />
            Paramètres cabine
          </span>
          {settingsOpen ? <FiChevronUp /> : <FiChevronDown />}
        </button>
        {settingsOpen && (
          <div className={styles.collapsibleContent}>
            <SettingsCab
              cabId={cab.id}
              setCabId={setCabId}
              cabType={cab.cabtype}
              name={cab.cabname}
              aboId={aboId}
              maj={maj}
              setMaj={setMaj}
              updateCabType={updateCabType}
              setUpdateCabType={setUpdateCabType}
              cabinesByAbo={cabinesByAbo}
              displaySettingCab={displaySettingCab}
              setDisplaySettingCab={setDisplaySettingCab}
              cabineAccess={cabineAccess}
              isSearchingSettingCab={isSearchingSettingCab}
              setIsSearchingSettingCab={setIsSearchingSettingCab}
            />
          </div>
        )}
      </div>

      {/* Section Adresse cabine */}
      <div className={styles.drawerSection}>
        <button
          type="button"
          className={styles.collapsibleHeader}
          onClick={() => setAddressOpen((prev) => !prev)}
        >
          <span className={styles.drawerSectionTitle}>
            <FaRegAddressCard className={styles.sectionIcon} />
            Adresse cabine
          </span>
          {addressOpen ? <FiChevronUp /> : <FiChevronDown />}
        </button>
        {addressOpen && (
          <div className={styles.collapsibleContent}>
            <ChangeAdressCab
              cabId={cabId}
              majCabine={majCabine}
              setMajCabine={setMajCabine}
            />
          </div>
        )}
      </div>

      {/* Section Informations spécifiques */}
      <div className={styles.drawerSection}>
        <button
          type="button"
          className={styles.collapsibleHeader}
          onClick={() => setInfosOpen((prev) => !prev)}
        >
          <span className={styles.drawerSectionTitle}>
            <IoMdInformationCircleOutline className={styles.sectionIcon} />
            Informations spécifiques
          </span>
          {infosOpen ? <FiChevronUp /> : <FiChevronDown />}
        </button>
        {infosOpen && (
          <div className={styles.collapsibleContent}>
            <SpecificInfosCab
              cabId={cabId}
              majCabine={majCabine}
              setMajCabine={setMajCabine}
            />
          </div>
        )}
      </div>
    </div>
  );
}
